import { SubscribeModal } from './SubscribeModal/SubscribeModal';
import { withContext } from '../hoc/withContext';

export const SubscribeModalWithContext = withContext(SubscribeModal);
